<template>
    <div>
        <label v-if="showTitle">
            {{ title }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <input
            :type="type"
            :name="name"
            class="form-control"
            :placeholder="title"
            :value="value"
            @input="change($event.target.value)"
            :maxlength="maximumlength"
            :class="{'is-invalid': error}"
            :disabled="isDisabled"
        />
        <div
            v-if="error"
            class="invalid-feedback"
        >
            {{ error }}
        </div>
    </div>    
</template>


<script>
    export default {
        props: {
            title: String,
            name: String,
            value: String,
            error: String,
            type: String,
            required: Boolean,
            maximumlength: String,
            showTitle: {
                type: Boolean,
                default: true
            },
            isDisabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            change(val) {
                this.$emit('input', val)
            }
        }
    }
</script>

